import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import Toast from '../components/Toast';
import slideImage1 from '../assets/images/homepage-slide-1.jpg';
import slideImage2 from '../assets/images/homepage-slide-2.jpg';
import slideImage3 from '../assets/images/homepage-slide-3.jpg';

const Home = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const location = useLocation();
    const [toastMessage, setToastMessage] = useState('');
    const [user, setUser] = useState(null);
    const [stats, setStats] = useState(null);
    const [bookmarkCount, setBookmarkCount] = useState(0);
    const [suggestedCourses, setSuggestedCourses] = useState([]);
    const [registeredCourseCount, setRegisteredCourseCount] = useState(0);

    // Create slides data based on user role
    const getSlidesData = () => {
        const baseSlides = [
            { id: 'slide1', img: slideImage1, link: '/profile', label: 'About Me' },
            { id: 'slide3', img: slideImage3, link: '/marathon-profile', label: 'Marathon Diaries' },
        ];
        
        // Add courses slide only for admin users
        if (user && user.role === 'admin') {
            baseSlides.splice(1, 0, { id: 'slide2', img: slideImage2, link: '/courses', label: 'Explore Courses' });
        }
        
        return baseSlides;
    };

    const slidesData = getSlidesData();

    useEffect(() => {
        const token = localStorage.getItem('app_token');
        if (token) {
            try {
                const decodedUser = jwtDecode(token);
                setUser(decodedUser);
                const fetchInitialData = async () => {
                    try {
                        const [statsRes, bookmarksRes, coursesRes] = await Promise.all([
                            axios.get('/api/allCount'),
                            axios.get('/api/bookmarks', { headers: { Authorization: `Bearer ${token}` } }),
                            axios.get('/api/users/my-courses', { headers: { Authorization: `Bearer ${token}` } })
                        ]);
                        const combinedStats = statsRes.data.reduce((acc, current) => ({ ...acc, ...current }), {});
                        setStats(combinedStats);
                        setBookmarkCount(bookmarksRes.data.length);
                        setRegisteredCourseCount(coursesRes.data.length);
                    } catch (error) { 
                        console.error("Failed to fetch initial data:", error);
                    }
                };
                fetchInitialData();
            } catch (error) {
                console.error("Invalid token:", error);
                setUser(null);
            }
        }
    }, []);

    useEffect(() => {
        const fetchCoursesForSuggestions = async () => {
            try {
                const response = await axios.get('/api/courses');
                setSuggestedCourses(response.data.sort(() => 0.5 - Math.random()).slice(0, 2));
            } catch (error) { console.error("Failed to fetch courses for suggestions:", error); }
        };
        fetchCoursesForSuggestions();
    }, []);

    useEffect(() => {
        if (location.state?.message) {
            setToastMessage(location.state.message);
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % slidesData.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slidesData.length]);

    return (
        <>
            {toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage('')} />}
            
            {user && (
                 <section className="welcome-card">
                    <div className="welcome-header">
                        <img src={user.profilePicture} alt={user.name} className="profile-image-small" />
                        <div className="welcome-text">
                            <span className="welcome-greeting">Welcome back,</span>
                            <span className="welcome-name">{user.name}!</span>
                        </div>
                        <div style={{ flexGrow: 1 }}></div> 
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            {/*
                                <Link to="/my-courses" className="welcome-bookmark-link">
                                    <span className="material-icons">school</span>
                                    <span>My Courses ({registeredCourseCount})</span>
                                </Link>
                            */}

                            <Link to="/my-bookmarks" className="welcome-bookmark-link">
                                <span className="material-icons">bookmarks</span>
                                <span>Bookmarks ({bookmarkCount})</span>
                            </Link>
                        </div>
                    </div>
                </section>
            )}
            

            <Link to={slidesData[currentSlide].link} className="profile-slideshow-link">
                <section className="slider-container">
                    <img src={slidesData[currentSlide].img} alt="" className="slider-ghost-image" />
                    {slidesData.map((slide, index) => (
                        <div key={slide.id} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                            <img src={slide.img} alt={slide.label} className="slide-image" />
                            <div className="slide-label">{slide.label}</div>
                        </div>
                    ))}
                </section>
            </Link>

            <section>
                <h2 className="section-title">Resources</h2>
                <div className="resource-grid">
                    <Link to="/articles" className="resource-card-home" style={{ textDecoration: 'none' }}><span className="material-icons">article</span><span className="resource-count">{stats?.article_count || '...'}</span></Link>
                    <Link to="/videos" className="resource-card-home" style={{ textDecoration: 'none' }}><span className="material-icons">videocam</span><span className="resource-count">{stats?.video_count || '...'}</span></Link>
                    <Link to="/reels" className="resource-card-home" style={{ textDecoration: 'none' }}><span className="material-icons">video_library</span><span className="resource-count">{stats?.reels_count || '...'}</span></Link>
                    <Link to="/podcasts" className="resource-card-home" style={{ textDecoration: 'none' }}><span className="material-icons">headphones</span><span className="resource-count">{stats?.podcast_count || '...'}</span></Link>
                    {user && (<Link to="/my-bookmarks" className="resource-card-home" style={{ textDecoration: 'none' }}><span className="material-icons">bookmarks</span><span className="resource-count">{bookmarkCount}</span></Link>)}
                </div>
            </section>
            
            {/*{suggestedCourses.length > 0 && (
                <section>
                    <h2 className="section-title">Suggested Courses</h2>
                    <div className="courses-list">
                        {suggestedCourses.map(course => (
                            <div key={course.id} className="course-card">
                                <img src={course.thumbnail} alt={course.title} className="course-card-image"/>
                                <div className="course-content">
                                    <h3>{course.title}</h3>
                                    <div className="course-meta">
                                        <div className="meta-item"><span className="material-icons">play_lesson</span><span>{course.lectures || 0} Lessons</span></div>
                                        <div className="meta-item"><span className="material-icons">sell</span><span>{course.price > 0 ? `₹${parseFloat(course.price).toFixed(2)}` : 'Free'}</span></div>
                                    </div>
                                    <Link to={`/courses/${course.id}`} className="course-button">View Course</Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            )}*/}
        </>
    );
};

export default Home;
